const ITEM_EDIT = 'portfoio-item-edit';
const ITEM_STOPLOSS_ALERT = 'portfoio-item-stoploss-alert';
const ITEM_REMOVE = 'portfolio-item-remove';
const ITEM_REMOVE_SUCCESS = 'portfolio-item-remove-succes';
const ITEM_TICK = 'portfoio-item-tick';
const ITEM_MOVE = 'portfolio-item-move';
const PORTFOLIO_CHANGED = 'portfolio-changed';

export default {
	ITEM_EDIT,
	ITEM_REMOVE,
	ITEM_REMOVE_SUCCESS,
	ITEM_STOPLOSS_ALERT,
	ITEM_TICK,
	ITEM_MOVE,
	PORTFOLIO_CHANGED,
};
